/**
* A widget for displaying a social media popup based on cookie consent and scroll position.
* The widget contains a randomly selected message from a predefined list and uses a fallback cookie to suppress the popup after a user has closed it.
* It can be customized with additional classes and specific CSS for styling.
*/
export default class SocialPopupWidget {
  constructor(options = {}) {
    this.options = {
      ctCookieName: 'CTwgt',         // Имя cookie для проверки согласия
      ctScrollY: 300,                // Отступ по скроллу для срабатывания (px)
      ctDNDExpireDays: 0.1,          // Срок хранения cookie о закрытии (дни, поддерживает дробные)
      ctHTML: ['<div class="mzk-txt gr1"><div class="mzk-icon mzk-tg"></div> <h4>Где на самом деле снимали «Девчат»?</h4> <p>Всё о советских фильмах, актёрах и режиссёрах рассказываем здесь! Оставайтесь на связи с любимым кино!</p><p class="s-btn-wrapper"><a class="mzk-link" target="_blank" rel="noopener noreferrer" href="https://t.me/+eDvF9PZri6w5Y2Ri"> Подписаться</a></p> </div>','<div class="mzk-txt gr1"><div class="mzk-icon mzk-tg"></div> <h4>Где на самом деле снимали «Девчат»?</h4> <p>Всё о советских фильмах, актёрах и режиссёрах рассказываем здесь! Оставайтесь на связи с любимым кино!</p><p class="s-btn-wrapper"><a class="mzk-link" target="_blank" rel="noopener noreferrer" href="https://t.me/+eDvF9PZri6w5Y2Ri"> Подписаться</a></p> </div>','<div class="mzk-txt gr2"> <div class="mzk-icon mzk-tg"></div><h4>Какие цитаты о возрасте из нашего кино знаете?</h4> <p>Всё о советских фильмах, актёрах и режиссёрах рассказываем здесь! Оставайтесь на связи с любимым кино!</p><p class="s-btn-wrapper"><a class="mzk-link" target="_blank" rel="noopener noreferrer" href="https://t.me/+eDvF9PZri6w5Y2Ri"> Подписаться</a></p></div>'],
      ctClass: '',                   // Дополнительные классы для виджета
      // Стили виджета
      ctCSS: `


.social-popup-widget {
  position:fixed;
  bottom:16px;
  left:50%;
  width:420px;
  background:white;
  border-radius:8px;
  -webkit-box-shadow:0 4px 24px rgba(0,0,0,.35);
  box-shadow:0 4px 24px rgba(0,0,0,.35);
  z-index:1000;
  padding:0;
  -webkit-transform:translate(-50%,120%);
  transform:translate(-50%,120%);
  -webkit-transition:all .5s ease-out .1s;
  transition:all .5s ease-out .1s;
  opacity:0;
  visibility:hidden;
  max-width:100%;
  font-family:"TT Norms",sans-serif
}
.social-popup-widget h4 {
  text-transform:uppercase;
  margin:0 auto .5em;
  text-align:left
}
.social-popup-widget.from-top {
  bottom:auto;
  top:16px;
  -webkit-transform:translate(-50%,-120%);
  transform:translate(-50%,-120%)
}
.social-popup-widget.is-mzk .mzk-txt:before {
  content:'';
  display:block;
  position:absolute;
  z-index:0;
  top:0;
  left:0;
  width:100%;
  height:100%
}
.social-popup-widget.is-mzk:before {
  display:none
}
.social-popup-widget.is-mzk .mzk-txt>* {
  position:relative;
  z-index:20
}
.social-popup-widget .mzk-txt {
  position:relative;
  z-index:10;
  overflow:hidden;
  display:block;
  padding:32px 16px 16px;
  position:relative
}
.social-popup-widget .mzk-txt p {
  display:block;
  overflow:hidden;
  line-height:1.25em
}
.social-popup-widget.is-mzk .mzk-txt:before {
  background-image:-webkit-gradient(linear,left top,right top,from(rgb(142,53,218)),color-stop(98%,rgb(42,45,237)),to(rgb(42,45,237)));
  background-image:linear-gradient(to right,rgb(142,53,218) 0%,rgb(42,45,237) 98%,rgb(42,45,237) 100%);
  display:block;
  position:absolute;
  top:0;
  left:0;
  z-index:10;
  width:100%;
  height:100%
}
.social-popup-widget.is-mzk .mzk-txt.gr1:before {
  background-image:-webkit-gradient(linear,left top,right top,from(rgb(238,86,91)),color-stop(98%,rgb(230,12,166)),to(rgb(230,12,166)));
  background-image:linear-gradient(to right,rgb(238,86,91) 0%,rgb(230,12,166) 98%,rgb(230,12,166) 100%)
}
.social-popup-widget.is-mzk .mzk-txt.gr2:before {
  background-image:-webkit-gradient(linear,left top,right top,from(rgb(255,198,0)),to(rgb(255,109,0)));
  background-image:linear-gradient(to right,rgb(255,198,0) 0%,rgb(255,109,0) 100%)
}
.social-popup-widget.is-mzk .mzk-txt.gr3:before {
  background-image:-webkit-gradient(to right,rgb(18,226,111) 0%,rgb(12,168,82) 100%);
  background-image:linear-gradient(to right,rgb(18,226,111) 0%,rgb(12,168,82) 100%)
}
.social-popup-widget.active {
  -webkit-transform:translate(-50%,0);
  transform:translate(-50%,0);
  opacity:1;
  visibility:visible;
  -webkit-transition:all .75s ease-out .5s;
  transition:all .75s ease-out .5s
}
.social-popup-close {
  position:absolute;
  top:10px;
  right:10px;
  background:none;
  border:none;
  font-size:18px;
  cursor:pointer;
  z-index:50;
  opacity:.5
}
.social-popup-content h3 {
  margin-top:0;
  color:#e5006a
}
.social-popup-widget.is-dark {
  background:#222;
  color:#fff
}
.social-popup-widget.is-dark .social-popup-close,
.social-popup-widget.is-mzk .social-popup-close {
  color:#fff;
  opacity:.75
}
@media (max-width:768px) {
  .social-popup-widget {
    bottom:0;
    width:100%
  }
  .social-popup-widget.social-popup-widget.from-top {
    bottom:auto;
    top:0
  }
}
.social-popup-widget p {
  margin:0 auto .5em;
  line-height:1.3em
}
.social-popup-widget .s-btn-wrapper {
  display:block;
  text-align:center;
  padding:1rem
}
.social-popup-widget .s-btn-wrapper a {
  display:inline-block;
  border:1px solid;
  text-transform:uppercase;
  padding:.25em .75em;
  font-size:.9em;
  font-weight:600;
  letter-spacing:.1em;
  -webkit-transition:all .25s ease-in-out;
  transition:all .25s ease-in-out
}
.social-popup-widget .s-btn-wrapper a:hover {
  color:rgb(142,53,218);
  background-color:#fff;
  border-color:#fff
}
.mzk-icon.mzk-tg {
  display:block;
  width:54px;
  height:54px;
  float:left;
  margin:0 16px 0 0;
  background-position:center;
  background-repeat:no-repeat;
  background-size:contain;
  opacity:1;
position: relative;
  overflow: visible;
perspective: 364px;  
}

.mzk-icon.mzk-tg:before {
  content:'';
 background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' viewBox='0 0 64 64'%3E%3ClinearGradient id='a' x1='.92' x2='62.92' y1='34' y2='34' gradientTransform='matrix(1 0 0 -1 0 66)' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%232AABEE'/%3E%3Cstop offset='1' stop-color='%23229ED9'/%3E%3C/linearGradient%3E%3Cpath fill='url(%23a)' fill-rule='evenodd' d='M5.2 28.4c16.7-7.2 27.7-12 33.3-14.3 15.8-6.6 19.1-7.8 21.3-7.8.5 0 1.5.1 2.3.7.6.5.7 1.1.8 1.6.1.4.2 1.4.1 2.2-.9 9-4.6 30.9-6.5 41-.8 4.3-2.4 5.7-3.9 5.9-3.3.3-5.9-2.2-9-4.3-5-3.3-7.8-5.3-12.8-8.5-5.7-3.7-2-5.8 1.2-9.1.9-.9 15.5-14.2 15.7-15.4 0-.1 0-.7-.3-1-.3-.3-.8-.2-1.2-.1-.5.1-8.5 5.4-24 15.9-2.3 1.6-4.3 2.4-6.2 2.3-2.1 0-5.9-1.2-8.9-2.1C3.5 34.2.7 33.6.9 31.7c.2-1.2 1.6-2.2 4.3-3.3z' clip-rule='evenodd'/%3E%3C/svg%3E");
  position: absolute;
  top:50%;
  left:50%;
  width: 32px;
  height: 32px;
  background-size: 100% auto;
  z-index: 50;
  background-position: center;
  background-repeat: no-repeat; 
  margin:-16px 0 0 -16px;
  animation: 6s Fly cubic-bezier(.68,-0.55,.43,1.35) infinite forwards;
}
.mzk-icon.mzk-tg:after {
  content:'';
  display: block;
  position: absolute;
  width:100%;
  height: 100%;
  background-color:rgba(255,255,255,0.85);
  border-radius: 50%;
  animation: 6s Coin cubic-bezier(.65,.05,.36,1) infinite;
  box-shadow:0 3px 12px rgba(0,0,0,0.15)
}
@keyframes Fly {
  0% {
    transform: translate(-48px,48px);
    opacity: 0;
    
  }
  20%,80% {
    transform: translate(0,0);
    opacity: 1
  }
  100% {
    transform: translate(48px,-48px);
    opacity: 0
  }
}
@keyframes Coin {
  0% {
transform: rotateY(0deg) translateZ(0px)
    
  }
  10%,40%,60%,90% {
    transform: rotateY(180deg) translateZ(-4px);
  
  }
  50% {transform:translateZ(64px) rotateY(180deg)}
  100% {
transform: rotateY(360deg) translateZ(0px);
  }
}

@media (max-width:640px) {
  .social-popup-widget p {
    line-height:1.3em
  }
}
.mzk-full-announce {
  color:#fff;
  display:block;
  position:relative;
  text-decoration:none;
  padding:0 32px 0 0
}
.mzk-full-announce:after {
  display:block;
  position:absolute;
  right:0;
  top:50%;
  content:'»';
  opacity:.25;
  font-weight:300;
  font-family:Georgia,serif;
  font-size:32px;
  height:48px;
  line-height:48px;
  -webkit-transform:translate(0,-50%);
  transform:translate(0,-50%);
  width:16px;
  -webkit-animation:1.5s GoTg ease-in-out infinite;
  animation:1.5s GoTg cubic-bezier(.46,.03,.52,.96) infinite
}
@-webkit-keyframes GoTg {
  0% {
    -webkit-transform:translate(-16px,-50%);
    transform:translate(-16px,-50%);
    opacity:0
  }
  20%,
  50% {
    -webkit-transform:translate(0,-50%);
    transform:translate(0,-50%);
    opacity:.5
  }
  100% {
    -webkit-transform:translate(16px,-50%);
    transform:translate(16px,-50%);
    opacity:0
  }
}
@keyframes GoTg {
  0% {
    -webkit-transform:translate(-16px,-50%);
    transform:translate(-16px,-50%);
    opacity:0
  }
  20%,
  50% {
    -webkit-transform:translate(0,-50%);
    transform:translate(0,-50%);
    opacity:.5
  }
  100% {
    -webkit-transform:translate(16px,-50%);
    transform:translate(16px,-50%);
    opacity:0
  }
}
.mzk-txt strong {
  white-space:nowrap
}
`,
      ...options
    };
    this.closedCookieName = 'SocialPopupWidgetClosed';
    this.checkInterval = null;
    this.initialized = false;
    this.init();
  }
  init() {
    if (this.initialized) return;
    this.checkCookieState();
    this.startCookieMonitoring();
  }
  startCookieMonitoring() {
    if (this.checkInterval) return;
    this.checkInterval = setInterval(() => this.checkCookieState(), 500);
  }
  stopCookieMonitoring() {
    clearInterval(this.checkInterval);
    this.checkInterval = null;
  }
  checkCookieState() {
    if (this.initialized || this.isClosed()) {
      this.stopCookieMonitoring();
      return;
    }
    if (this.hasConsent()) {
      this.initializeWidget();
      this.stopCookieMonitoring();
    }
  }

  hasConsent() {
    return document.cookie.split(';')
      .some(c => c.trim().startsWith(`${this.options.ctCookieName}=`));
  }
  isClosed() {
    if (!this.options.ctDNDExpireDays || this.options.ctDNDExpireDays <= 0) {
      return false;
    }
    return document.cookie.split(';')
      .some(c => c.trim().startsWith(`${this.closedCookieName}=true`));
  }
  initializeWidget() {
    if (this.initialized) return;
    this.initialized = true;
    this.addStyles();
    this.setupScrollTrigger();
  }
  addStyles() {
    if (document.getElementById('social-popup-styles')) return;
    const style = document.createElement('style');
    style.id = 'social-popup-styles';
    style.textContent = this.options.ctCSS;
    document.head.appendChild(style);
  }
  setupScrollTrigger() {
    const handler = () => {
      if (window.scrollY >= this.options.ctScrollY) {
        this.showWidget();
        window.removeEventListener('scroll', handler);
      }
    };
    window.addEventListener('scroll', handler);
    handler();
  }
  showWidget() {
    // Выбираем случайный HTML из массива
    const randomIndex = Math.floor(Math.random() * this.options.ctHTML.length);
    const content = this.options.ctHTML[randomIndex];

    // Формируем классы
    const classes = ['social-popup-widget', ...this.options.ctClass.trim().split(/\s+/)];

    // Создаем HTML
    document.body.insertAdjacentHTML('beforeend', `
      <div class="${classes.join(' ')}">
        <button class="social-popup-close" aria-label="Закрыть">&times;</button>
        ${content}
      </div>
    `);

    const widget = document.querySelector('.social-popup-widget');
    const closeBtn = document.querySelector('.social-popup-close');

    // Анимация появления
    setTimeout(() => widget.classList.add('active'), 100);

    // Обработчик закрытия
    closeBtn.addEventListener('click', () => {
      widget.classList.remove('active');
      setTimeout(() => {
        widget.remove();
        if (this.options.ctDNDExpireDays > 0) {
          this.setClosedCookie();
        }
      }, 300);
    });
  }

  setClosedCookie() {
    const date = new Date();
    // Поддержка дробных значений (0.1 дня = 2.4 часа)
    date.setTime(date.getTime() + (this.options.ctDNDExpireDays * 24 * 60 * 60 * 1000));
    document.cookie = `${this.closedCookieName}=true; expires=${date.toUTCString()}; path=/`;
  }

  destroy() {
    this.stopCookieMonitoring();
    document.querySelector('.social-popup-widget')?.remove();
    document.getElementById('social-popup-styles')?.remove();
    this.initialized = false;
  }
}